// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"

const modelClassData = {
  "attributes": {
    "confirmed_at": {
      "column": {
        "default": null,
        "name": "confirmed_at",
        "null": true,
        "type": "datetime"
      },
      "name": "confirmed_at",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": {
        "default": null,
        "name": "email",
        "null": false,
        "type": "string"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "primary": {
      "column": {
        "default": false,
        "name": "primary",
        "null": false,
        "type": "boolean"
      },
      "name": "primary",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Email",
  "collectionKey": "emails",
  "collectionName": "emails",
  "i18nKey": "email",
  "camelizedLower": "email",
  "name": "Email",
  "nameDasherized": "email",
  "pluralName": "emails",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "person_id",
      "name": "user",
      "macro": "has_one",
      "resource_name": "User",
      "through": "contact"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "confirmation_sent_at",
      "column": {
        "default": null,
        "name": "confirmation_sent_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "confirmation_threshold_enabled",
      "column": {
        "default": true,
        "name": "confirmation_threshold_enabled",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "confirmation_token",
      "column": {
        "default": null,
        "name": "confirmation_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "confirmed_at",
      "column": {
        "default": null,
        "name": "confirmed_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_unconfirmed_email",
      "column": {
        "default": null,
        "name": "old_unconfirmed_email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "primary",
      "column": {
        "default": false,
        "name": "primary",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "email",
  "primaryKey": "id"
}

/** Frontend model for Email. */
export default class Email extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date | null} */
  confirmedAt() {
    return this.readAttributeUnderscore("confirmed_at")
  }

  /** @returns {boolean} */
  hasConfirmedAt() {
    const value = this.confirmedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  primary() {
    return this.readAttributeUnderscore("primary")
  }

  /** @returns {boolean} */
  hasPrimary() {
    const value = this.primary()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static confirm(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "confirm",
        collectionName: "emails",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  adminConfirm(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "admin_confirm",
        primaryKey: this.primaryKey(),
        collectionName: "emails",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }
}
